export const siderbarDefaultWidth = 440

const state = {
  namespaced: true,
  state: {
    siderbarWidth: siderbarDefaultWidth,
    pointBasicInfo: {}, // 点的基本信息
    pointDetailInfo:{
      typeOfPoi: 0,
      pakingValue: '',
      basicInfo: {},
    }, // detail cards 所需的一些信息
    leftDrawer: {type: null, show: false},
    showLeftDrawerList: [
      // {
      //   type: '',
      //   actions: '',
      //   root: false,
      //   width: 520,
      //   params: null,
      // }
    ],
    showSecondarySiderbar: false,
    secondarySiderbarInfo: {
      type: 'pointOption',
      waypointUniqueIdentifier: null
    }
  },
  mutations: {
    POI_DETAIL_UPDATE_LEFT_DRAWER(state, data){
      state.leftDrawer = Object.assign({}, state.leftDrawer, data)
    },
    SET_POINT_BASIC_INFO(state, info) {
      state.pointBasicInfo = info
    },
    SET_POINT_DETAIL_INFO(state, info) {
      state.pointDetailInfo = info
    },
    SET_SIDERBAR_WIDTH(state, width) {
      state.siderbarWidth = width
    },
    SET_SHOW_LEFT_DRAWER_LIST(state, list) {
      state.showLeftDrawerList = list
    },
    SET_SHOW_SECONDARY_SIDERBAR(state, status) {
      state.showSecondarySiderbar = status
    },
    SET_SECONDARY_SIDERBAR_INFO(state, info) {
      state.secondarySiderbarInfo = info
    }
  },
  actions: {
    updatePointBasicInfo({ commit }, info) {
      commit('SET_POINT_BASIC_INFO', info);

    },
    updatePointDetailInfo({commit }, info){
      let typeOfPoi = 0;
      let pakingValue = '';
      if ((info.tid === 2 && info.sid !== 3) || info.tid === 3 || info.tid === 8 || info.tid === 4) {
        typeOfPoi = 2;
        pakingValue = 'LAST PARKING STATUS';
      } else if (info.tid === 1) {
        typeOfPoi = 3;
        pakingValue = 'LAST WEIGH STATION STATUS';
      } else if (info.tid === 16) {
        typeOfPoi = 4;
        pakingValue = 'LAST DOCK STATUS';
      }
      commit('POI_DETAIL_UPDATE_LEFT_DRAWER', {show: false})
      commit('SET_POINT_DETAIL_INFO', {
        typeOfPoi,
        pakingValue,
        basicInfo: info
      })
    },
    showAllHistory({commit}) {
      commit('POI_DETAIL_UPDATE_LEFT_DRAWER', {type: 'all-history', show: true})
    },
    showAllRest({commit}) {
      commit('POI_DETAIL_UPDATE_LEFT_DRAWER', {type: 'all-rest', show: true})
    },
    showAllReviews({commit}) {
      commit('POI_DETAIL_UPDATE_LEFT_DRAWER', {type: 'all-reviews', show: true})
    },
    hideLeftDrawer({commit}) {
      commit('POI_DETAIL_UPDATE_LEFT_DRAWER', {show: false})
    },
    updateSiderbarWidth({ commit }, width) {
      commit('SET_SIDERBAR_WIDTH', width || siderbarDefaultWidth)
    },
    updateShowSecondarySiderbar({ commit }, status) {
      commit('SET_SHOW_SECONDARY_SIDERBAR', status)
    },
    updateSecondarySiderbarInfo({ commit }, info) {
      commit('SET_SECONDARY_SIDERBAR_INFO', info)
    },
    pushLeftDrawer({ commit, state, dispatch }, info) {
      commit('SET_SHOW_LEFT_DRAWER_LIST', [...state.showLeftDrawerList, info])
      dispatch('updateSiderbarWidth', info.width)
      dispatch(info.actions, {...info.params, isShow: true}, { root: info.root })
    },
    replaceLeftDrawer({ commit, state, dispatch }, info) {
      let list = state.showLeftDrawerList.slice(0, state.showLeftDrawerList.length - 1)
      commit('SET_SHOW_LEFT_DRAWER_LIST', [...list, info])
      dispatch('updateSiderbarWidth', info.width)
      dispatch(info.actions, {...info.params, isShow: true}, { root: info.root })
    },
    popLeftDrawer({ commit, state, dispatch }) {
      let list = state.showLeftDrawerList.slice(0, state.showLeftDrawerList.length - 1)
      let closeDrawer = state.showLeftDrawerList[state.showLeftDrawerList.length - 1]
      let lastDrawer = list[list.length - 1]
      commit('SET_SHOW_LEFT_DRAWER_LIST', list)
      dispatch('updateSiderbarWidth', lastDrawer ? lastDrawer.width : siderbarDefaultWidth)
      dispatch(closeDrawer.actions, {...closeDrawer.params, isShow: false}, { root: closeDrawer.root })
    }
  }
}

export default state
